import i18n from 'i18next';

// Its own namespace: the skeleton is in the initial bundle and must not pull the module's copy.
export const NS = 'agent-settings-skeleton';

export const en = { loading: "Loading the agent's settings" };
export const es: typeof en = { loading: 'Cargando la configuración del agente' };
export const pt: typeof en = { loading: 'Carregando as configurações do agente' };

// Guarded so importing this is safe where the i18next singleton isn't initialized (jest).
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}
